import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppService } from 'src/app/services/app/app.service';
import { CommonService } from 'src/app/services/common/common.service';
import { UserManagementService } from 'src/app/services/user_management/user-management.service';

@Component({
  selector: 'app-agree-terms-condition',
  templateUrl: './agree-terms-condition.component.html',
  styleUrls: ['./agree-terms-condition.component.scss']
})
export class AgreeTermsConditionComponent {
  constructor(private userService:UserManagementService,private appService:AppService,private spinner:NgxSpinnerService,
    public dialogRef: MatDialogRef<AgreeTermsConditionComponent >,
    private commonService:CommonService){}
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    
  }
  onSubmit(){
    // this.dialogRef.close({accepted:true})
    let data={
      t_acp :1
    }
    this.userService.acceptTermsCommission(data).subscribe({
      next: (success: any) => {
       this.spinner.hide()
        if (success.status == 200) {
          this.appService.showToastMessage('success',success.msg)
          this.dialogRef.close({accepted:true})
        }
      },
      error: (error: any) => {
        this.spinner.hide()
        this.commonService.handleError(error);
      },
    });
  }
}
